import React, { Component } from 'react'
import classnames from 'classnames'
import { Col, Row } from 'react-flexbox-grid'
import Card from '@material-ui/core/Card'
import Divider from '@material-ui/core/Divider'
import { withStyles } from '@material-ui/core/styles'
import Columns from '../../styles/columns'
import CardStyles from '../../styles/cards'
import TitledLabel from '../../controls/TitledLabel'
import { localize } from '../../util/Localizer'

class Dependents extends Component {
  render () {
    const { classes = {} } = this.props

    return (
      <div>
        <Col>
          <h4 className='sectionHeading'>{localize('pages.memberSummary.dependentHeader')}</h4>
          {
            this.props.dependentsSummary.map(function (dependent, indx) {
              return <div key={indx}>
                <Card className={ classnames(classes.summaryCard, classes.baseCard) }>
                  <Row>
                    <Col {...Columns.max6}>
                      <p className='cardTitle'>{`${dependent.firstName} ${dependent.lastName}`}</p>
                    </Col>
                  </Row>
                  <Divider />
                  <Row>
                    <Col {...Columns.max6}>
                      <TitledLabel title='pages.memberSummary.dependents.relationship' value={dependent.relationship} format='text' />
                    </Col>
                    <Col {...Columns.max6}>
                      <TitledLabel title='pages.memberSummary.dependents.birthDate' value={dependent.birthDate} format='date' />
                    </Col>
                    <Col {...Columns.max6}>
                      <TitledLabel title='pages.memberSummary.dependents.status' value={dependent.status} format='text' />
                    </Col>
                  </Row>
                </Card>
              </div>
            })
          }
        </Col>
      </div>
    )
  }
}

const styles = {
  ...CardStyles
}

export default withStyles(styles)(Dependents)



// WEBPACK FOOTER //
// ./src/widgets/Member/Dependents.js